import { render, staticRenderFns } from "./BlockFooter.vue?vue&type=template&id=3b591a4e&scoped=true&"
import script from "./BlockFooter.vue?vue&type=script&lang=js&"
export * from "./BlockFooter.vue?vue&type=script&lang=js&"
import style0 from "./BlockFooter.vue?vue&type=style&index=0&id=3b591a4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b591a4e",
  null
  
)

export default component.exports